import { render } from "./UserUnidadNegocio.vue?vue&type=template&id=791cf6d2"
import script from "./UserUnidadNegocio.vue?vue&type=script&lang=js"
export * from "./UserUnidadNegocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__